<template>
    <div class="main" v-loading.fullscreen="isLoad" element-loading-background="rgba(0, 0, 0,0)">
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item>营销</el-breadcrumb-item>
            <el-breadcrumb-item>满减</el-breadcrumb-item>
            <el-breadcrumb-item>{{$route.query.id ? '编辑满减' : '添加满减'}}</el-breadcrumb-item>
        </el-breadcrumb>
        <div class="dis-flex">
            <div class="second-swaper">
                <second></second>
            </div>
            <div class="flex-box">
                <Card :bordered="false" dis-hover class="ivu-mt">
                    <Form
                            class="formValidate mt20"
                            ref="formValidate"
                            :rules="ruleValidate"
                            :model="formValidate"
                            :label-width="120"
                            @submit.native.prevent>
                        <FormItem label="满减名称：" prop="manjian_name">
                            <Input
                                    v-model="formValidate.manjian_name"
                                    placeholder="请输入满减名称"
                                    v-width="'50%'"/>
                        </FormItem>
                        <Col span="24">
                            <FormItem label="活动时间：" prop="section_time">
                                <div class="acea-row row-middle">
                                    <DatePicker :editable="false" type="datetimerange" format="yyyy/MM/dd" placeholder="请选择活动时间"
                                                @on-change="onchangeTime" class="perW30" :value="formValidate.section_time" v-model="formValidate.section_time"></DatePicker>
                                    <div class="ml10 ivu-form-item-content">设置活动开启结束时间，用户可以在设置时间内发起参与秒杀</div>
                                </div>
                                <div class="warn ivu-form-item-content">为保证活动时间的唯一性，添加活动后，活动时间不能修改！</div>
                            </FormItem>
                        </Col>
                        <FormItem label="满减类型：" prop="type">
                            <RadioGroup v-model="formValidate.type">
                                <Radio :label="10" class="radio">满N元</Radio>
                                <Radio :label="20">满N件</Radio>
                            </RadioGroup>
                        </FormItem>
                        <FormItem label="优惠内容：" prop="type">
                            <div class="mar_b20" v-for="(rule, index) in formValidate.rule_json">
                                <span class="ml10 mr10">满</span>
                                <InputNumber class="ml10" v-model="rule.full_money" placeholder="门槛金额"></InputNumber>
                                <span class="ml10 mr10">{{formValidate.type == 10 ? '元' : '件'}}</span>
                                <span class="ml10 mr10">减</span>
                                <InputNumber v-model="rule.reduce" placeholder="力度金额"></InputNumber><span class="ml10">{{formValidate.type == 10 ? '元' : '件'}}</span>
                                <span class="mar_l15 curs" @click="delRule(index)">删除</span>
                            </div>
                            <div class="mar_t15 curs">
                                <div @click="addRule" class="mar_t15 color_primary">+ 添加满减</div>
                            </div>
                        </FormItem>

                        <FormItem label="启用状态：" prop="status">
                            <RadioGroup v-model="formValidate.status">
                                <Radio :label="1" class="radio">启用</Radio>
                                <Radio :label="0">关闭</Radio>
                            </RadioGroup>
                        </FormItem>
                        <FormItem label="满减描述：" prop="describe">
                            <Input type="textarea" v-model="formValidate.describe"
                                   placeholder="请输入满减描述"
                                   v-width="'50%'"/>
                        </FormItem>
                        <FormItem label="" prop="">
                            <Button
                                    type="primary"
                                    class="submission"
                                    @click="handleSubmit('formValidate')">
                                保存
                            </Button>
                        </FormItem>
                    </Form>
                </Card>
            </div>
        </div>
    </div>
</template>

<script>
    import { formatDate } from "@/utils/validate";
    import second from "./second.vue";
    export default {
        name: "add",
        components: { second },
        data () {
            return {
                isLoad: false,
                manjian_id: 0,
                record: false,
                formValidate: {
                    type: 10,
                    status: 1,
                    total_num: 0,
                    expire_type: 10,
                    apply_range: 10,
                    sort: 100,
                    between_time: [],
                    rule_json: [
                        {
                            full_money: 0,
                            reduce: 0,
                            discount: 0
                        }
                    ],
                },
                ruleValidate: {
                    manjian_name: [
                        {required: true, message: "请输入满减名称"},
                    ],
                    type: [
                        {required: true, message: "请选择满减类型"},
                    ],
                    reduce_price: [
                        {required: true, message: "请输入减免金额"},
                    ],
                    min_price: [
                        {required: true, message: "请输入最低消费金额"},
                    ],
                    expire_type: [
                        {required: true, message: "请选择到期类型"},
                    ],
                    expire_day: [
                        {required: true, message: "请输入有效期天数"},
                    ],
                    between_time: [
                        {required: true, message: "请选择有效期范围"},
                    ],
                    total_num: [
                        {required: true, message: "请输入发放总数量"},
                    ],
                    status: [
                        {required: true, message: "请选择显示状态"},
                    ],

                }
            }
        },
        mounted() {
            if (this.$route.query.id !== "0" && this.$route.query.id) {
                this.getInfo();
            } else if (this.$route.query.id === "0") {
            }
        },
        methods: {
            getInfo: function () {
                this.axios.post('store/app.manjian/detail', {
                    manjian_id: this.$route.query.id
                })
                .then(async (res) => {
                    if (res.code == 1) {
                        // 当前记录
                        this.record = res.data.model
                        this.manjian_id = this.record.manjian_id
                        // 设置表单默认值
                        this.setFieldsValue()
                    }
                })
            },
            setFieldsValue: function () {
                const { record } = this

                // 表单数据
                const data = _.pick(record, [
                    'manjian_name', 'type', 'goods_type', 'manjian_type', 'rule_json', 'status', 'describe'
                ])
                data.section_time = [
                    formatDate(new Date(record.start_time * 1000), "yyyy/MM/dd"),
                    formatDate(new Date(record.end_time * 1000), "yyyy/MM/dd")
                ]

                this.formValidate = data
            },
            // 具体日期
            onchangeTime(e) {
                this.timeVal = e;
                if (e.length == 2) {
                    this.formValidate.between_time = this.timeVal
                }
            },
            // 提交
            handleSubmit(name) {
                this.$refs[name].validate((valid) => {
                    if (valid) {
                        var form = _.cloneDeep(this.formValidate)
                        if (this.manjian_id) {
                            this.axios.post('store/app.manjian/edit', {
                                manjian_id: this.manjian_id,
                                form: form
                            })
                            .then(async (res) => {
                                this.openSubimit = false;
                                this.$Message.success(res.msg);
                                setTimeout(() => {
                                    this.$router.push({path: "/app/manjian/list.html"});
                                }, 1500);
                            })
                            .catch((res) => {
                                this.openSubimit = false;
                                this.$Message.error(res.msg);
                            });
                        } else {
                            this.axios.post('store/app.manjian/add', {
                                form: form
                            })
                                .then(async (res) => {
                                    this.openSubimit = false;
                                    this.$Message.success(res.msg);
                                    setTimeout(() => {
                                        this.$router.push({path: "/app/manjian/list.html"});
                                    }, 500);
                                })
                                .catch((res) => {
                                    this.openSubimit = false;
                                    this.$Message.error(res.msg);
                                });
                        }
                    }
                })
            },
            delRule: function (index) {
                this.formValidate.rule_json.splice(index, 1)
            },
            addRule: function () {
                this.formValidate.rule_json.push({
                    full_money: 0,
                    reduce: 0,
                    discount: 0
                })
            }
        }
    }
</script>

<style scoped>

</style>
